export enum DateType {
  CreatedOn = 'createdon',
  CheckIn = 'checkin',
  CheckOut = 'checkout'
}

export enum AvailableReportType {
  Hotel = 'hotel',
  User = 'user',
  Passenger = 'passenger',
  Division = 'division',
  Reservation = 'reservation',
  FlightSpend = 'flightSpend',
  OutOfPolicy = 'Report_OutOfPolicy',
  Trainline = 'trainline',
  RoomexPay = 'roomexpay',
  ClientField = 'client_field',
}

export interface ReportingConfiguration {
  availableReports: AvailableReportType[];
  clientFieldReports: string[];
  currencyCode: string;
  dateType: DateType;
}

export interface ReportingConfigResponse {
  configuration: {
    reports: ReportingConfiguration;
  };
}

